import './upload-container.style.scss';
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { token } from '../../../../util/store';
import useUploadContainer from './use-upload-container.hook';
import { useTranslation } from 'react-i18next';

interface UploadContainerProps {
  idMatricula: number;
}

export default function UploadContainer({ idMatricula }: UploadContainerProps) {
  const {
    upload,
    form
  } = useUploadContainer({ idMatricula });
  const { t } = useTranslation('gestao_de_aulas');

  return (
    <div className={'upload-container'}>
      <div className={'upload-container__project-upload'}>
        <label className={'project-upload__label'}>{t('gestao_de_aulas:uploadProjectLabel')}</label>
        <Upload
          headers={{ Authorization: `Bearer ${token()}` }}
          action={`${process.env.REACT_APP_HAPPYCODE_PUBLIC_BASE_URL_API}arquivo/upload/projetos`}
          onChange={upload.onChange}
          maxCount={1}
          beforeUpload={upload.before}
          className={'project-upload__upload'}
          fileList={form.fileList}
          disabled={form.disabled}
        >
          <UploadOutlined className={'upload__upload-icon'} />
        </Upload>
      </div>
    </div>
  );
}
